import store from '../../store'
const { cloneDeep } = require('lodash')
import {
  getUserDateAndTime,
  getUserTimezone,
  getVisitorAttributes
} from '../utils'

export default {
  getDigitalVoiceEnabled() {
    return {
      type: 'TEXT',
      name: 'digital_voice_enabled',
      value: 'true',
      scope: 'LIFE_TIME'
    }
  },

  getUserTimezoneAttribute() {
    return {
      type: 'TEXT',
      name: 'user_timezone',
      value: getUserTimezone(),
      scope: 'LIFE_TIME'
    }
  },

  getUserDateAndTimeAttribute() {
    return {
      type: 'TEXT',
      name: 'user_date_time',
      value: getUserDateAndTime(),
      scope: 'LIFE_TIME'
    }
  },

  getWidgetId() {
    return {
      type: 'TEXT',
      name: 'widget_id',
      value: store.state.widgetId,
      scope: 'LIFE_TIME'
    }
  },

  getDeptHandoffCode() {
    return {
      type: 'TEXT',
      name: 'dept_handoff_code',
      value: null,
      scope: 'LIFE_TIME'
    }
  },

  triggerResponse() {
    return {
      type: 'TEXT',
      name: 'resume_bot_response',
      value: 'false',
      scope: 'LIFE_TIME'
    }
  },

  getWidgetVisitorInfo() {
    const widgetVisitorInfo = store.state.widgetVisitorInfo
    const widgetVisitorInfoMap = []
    Object.keys(widgetVisitorInfo).forEach((infoKey) => {
      widgetVisitorInfoMap.push({
        type: 'TEXT',
        name: infoKey,
        value: widgetVisitorInfo[infoKey],
        scope: 'LIFE_TIME'
      })
    })
    return widgetVisitorInfoMap
  },

  getDefaultAttributes() {
    const defaulAttributesInState = store.state.defaultAttributes

    if (defaulAttributesInState.length > 0) {
      return defaulAttributesInState
    }
    const defaultAttributes = cloneDeep(getVisitorAttributes())

        const defaultAttributesMap = []
        Object.keys(defaultAttributes).forEach(attribute => {
            defaultAttributesMap.push({
                type: 'TEXT',
                name: attribute,
                value: defaultAttributes[attribute],
                scope: "LIFE_TIME"
            })
        })
        store.dispatch('updateDefaultAttributes', defaultAttributesMap)
        return defaultAttributesMap
    },
    getCustomVisitorInfo() {
        const customVisitorInfoInState = store.state.visitorInfoForm.visitorInfoDetails
        const customVisitorInfoMap = []
        Object.keys(customVisitorInfoInState).forEach(infoKey => {
            customVisitorInfoMap.push({
                type: 'TEXT',
                name: infoKey,
                value: customVisitorInfoInState[infoKey],
                scope: "LIFE_TIME"
            })
        })
        return customVisitorInfoMap
    }
}
